/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_External_Code_EmptyInputs */

const en_case_field_external_code_empty = /** @type {(inputs: Case_Field_External_Code_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No external code`)
};

const pt_br2_case_field_external_code_empty = /** @type {(inputs: Case_Field_External_Code_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem código externo`)
};

/**
* | output |
* | --- |
* | "No external code" |
*
* @param {Case_Field_External_Code_EmptyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_external_code_empty = /** @type {((inputs?: Case_Field_External_Code_EmptyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_External_Code_EmptyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_external_code_empty(inputs)
	return pt_br2_case_field_external_code_empty(inputs)
});